import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const applicationApi = createApi({
  reducerPath: "applicationApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createApplication: builder.mutation({
      query: (newApplication) => ({
        url: "application/",
        method: "POST",
        body: newApplication,
      }),
    }),
    updateApplication: builder.mutation({
      query: ({ id, updatedApplication }) => ({
        url: `application/${id}`,
        method: "PUT",
        body: updatedApplication,
      }),
    }),
    applyApplication: builder.mutation({
      query: ({ id, updatedApplication }) => ({
        url: `application/apply/${id}`,
        method: "PUT",
        body: updatedApplication,
      }),
    }),
    getApplications: builder.query({
      query: (params) => ({
        url: "application/",
        params,
      }),
    }),
    getApplicationById: builder.query({
      query: (applicationId) => ({
        url: `application/${applicationId}`,
      }),
    }),
  }),
});

export const {
  useCreateApplicationMutation,
  useUpdateApplicationMutation,
  useApplyApplicationMutation,
  useGetApplicationsQuery,
  useGetApplicationByIdQuery,
} = applicationApi;